import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Message, Button } from 'semantic-ui-react'
// import _find from 'lodash/find';
// import _ from 'lodash';

import ListaDe from '../../../components/funcionales/dirmayor/listade';
import ListaCi from '../../../components/funcionales/dirmayor/listaci';
import ListaZo from '../../../components/funcionales/dirmayor/listazo';
import ListaBa from '../../../components/funcionales/dirmayor/listaba';
import selDirmayor from '../../../functions/seldirmayor';

//utils
import queries from '../../../utils/queries'

import SeguroPermite from '../../../components/funcionales/seguropermite'

// "use strict";

//dropdown CLASES
const DetalleNivel1 = props => {
  return (
    <option dato1={props.elemento.codigoClaseServ} value={props.elemento._id} style={props.styles.input}>{props.elemento.descrClaseServ}</option>
  )
};

const Lista = ({styles, handleLista4, list}) => {
    const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
    return(
        <div>
            <select style={styles.input} className="ui simple selection dropdown fluid" name="clase" id="miLista4" onChange={handleLista4}>
                <option style={styles.input} value="">Todas...</option>
                {Nivel1Detalle}
            </select>
        </div>
    )
};
//Fin dropdown CLASES

//dropdown TARIFAS
const DetalleSelTar = props => {
  return (
    <option value={props.elemento.codigoTarifa}>{props.elemento.codigoTarifa} ={">"} {props.elemento.descrTarifa}</option>
  )
};

//Tarifa nueva
const ListaTarN = ({styles, list, handleChange}) => {
  const detalleTar = list.map((elemento, _id) => <DetalleSelTar styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="tarifaN" id="tarifaN" onChange={(ev)=>handleChange(ev)}>
        <option value="">Todas...</option>
        {detalleTar}
      </select>
    </div>
  )
};
//Fin dropdown TARIFAS
//Lista de candidatos a DX
const FactCli = ({elemento}) => {
  return(
    <tr className=''>
      <td className=''>{elemento.contrato}</td>
      <td className=''>{elemento.descrClaseServ}</td>
      <td className=''>{elemento.descripcionServicio}</td>
      <td className=''>{elemento.descrClaseServM}</td>
      <td className=''>{elemento.descripcionServicioM}</td>
      <td className=''>{elemento.documento}</td>
      <td className='right aligned'>{elemento.valorTotal}</td>
      <td className='right aligned'>{elemento.valorPagado}</td>
      <td className=''>{elemento.pagueHasta.substr(0, 10)}</td>
      <td className=''>{elemento.diasMora}</td>
      <td className=''>{elemento.numVecesDX}</td>
    </tr>
  )
};

const ListaDX = ({list}) => {
  const nivel1Detalle = list.map((elemento, i) => <FactCli elemento={elemento} key={i}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

// let diasMora = 30
// let fecha = new Date();
// // let fechaMora = fecha.setDate(fecha.getUTCDate() - diasMora)
// // fechaMora = new Date(fechaMora)
// // fechaMora = (fechaMora.getFullYear()) + '-' + ((fechaMora.getMonth()+1)<10?'0'+(fechaMora.getMonth()+1):(fechaMora.getMonth()+1)) + '-' + (fechaMora.getUTCDate()<10?'0'+fechaMora.getUTCDate():fechaMora.getUTCDate())

// // let fechaHoy = new Date()
// // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())

const argsBuscarMC = {tipo: "X"}
// const argsBuscarMC = {tipo: "C", pagueHasta: { $lte: fechaMora }, numeroOdeDX: 0}
const argsBuscarCL = {estadoCliente: "ACTIVO", numDocum: 1}

class ProcDX2 extends React.Component {
  state={argsDocum: {_id: "",  fechaRef: "", saldoPendiente: 5000, diasMora: 30, porcMovim: 0, valorMovim: 0, diasDXDesde: 365, numVecesDX: 0,
        descrDpto: "Todos...", nombreCiudad: "Todas...", nombreZona: "Todas...",
        nombreBarrio: "Todos...", codigoTarifaN: "Todas..."},
        argsProc: {}, servaDX: "todos", argsSelDpto: this.props.argsSelDpto, creaDetDX: [], totCli: 0,
        permiteUpdate: true, confirmaAct: false, open: false, errors: []}

  nextVal = async (name) => {
    const argsUpd1 = {
        coleccion: name,
      }
      const response = await this.props.editSeqfindOneAndUpdate({
        variables: argsUpd1
      });
      return response.data.editSeqfindOneAndUpdate.seq
  }

  handleChange = (ev) => {
    let creaDetDX = [], argsProc = {}
    this.setState({creaDetDX})
    this.setState({argsProc})
    if(ev.target.name==="opcServaDX"){
      if(ev.target.checked===true){
        this.setState({servaDX: ev.target.value})
      }
    }else{
      if(ev.target.name!=="fechaRef"){      // no permitir modificar la fecha de referencia
        const argsDocum = this.state.argsDocum
        if(ev.target.name === "tarifaN"){
          let miLista = document.getElementById("tarifaN");
          if(miLista.options[miLista.selectedIndex].text!=="Todas..."){
            argsDocum['codigoTarifaN'] = miLista.options[miLista.selectedIndex].value
          }else{
            argsDocum['codigoTarifaN'] = "Todas..."
          }
        }else{
          if(ev.target.name==="porcMovim"||ev.target.name==="valorMovim"||ev.target.name==="saldoPendiente"){
            argsDocum[ev.target.name] = parseInt(ev.target.value, 10)
          }else{
            argsDocum[ev.target.name] = ev.target.value
          }
        }
        this.setState({argsDocum});
      }
    
      // if(ev.target.name==="fechaRef"||ev.target.name==="diasMora"){
        // let diasMora = this.state.argsDocum.diasMora, fecha = new Date(this.state.argsDocum.fechaRef)
        // if(ev.target.name==="fechaRef"){
        //   fecha = new Date(ev.target.value);
        // }else{
        //   diasMora = ev.target.value
        // }
        // let fechaMora = fecha.setDate(fecha.getUTCDate() - diasMora)
        // fechaMora = new Date(fechaMora)
        // fechaMora = (fechaMora.getFullYear()) + '-' + ((fechaMora.getMonth()+1)<10?'0'+(fechaMora.getMonth()+1):(fechaMora.getMonth()+1)) + '-' + (fechaMora.getUTCDate()<10?'0'+fechaMora.getUTCDate():fechaMora.getUTCDate())
        
        // const argsBuscarMC = {tipo: "C", pagueHasta: { $lte: fechaMora }, numeroOdeDX: 0}
        // this.props.allMovTodos.refetch(argsBuscarMC)
        // console.log(argsBuscarMC)
      // }
    }
  }

  handleSubmit = async (ev)=>{
    // console.log(ev.target.name)
// if(ev.target.name==="pantalla"){
//   console.log("click en pantalla")
// }else{
//   console.log("generar dx")
// }
//ACTUALIZAR BD
async function crudBD(operacionCRUD, args, i) {
  console.log("CRUD")
        if(args.ctrlCampo === 'CRUD'){
  // console.log(i)
  // console.log(args)
          const {data} = await operacionCRUD({
            variables: args
          });
  
  //Se utiliza para traer el _id del documento creado
          if(args.ctrl_id === 'SI_ID'){
            if(Object.values(data)[0]._id){
              return Object.values(data)[0]._id
            }else{
              return 0
            }
          }
        }else{
          if(args.ctrlCampo === "MANY"){
            // console.log("MANY")
            // console.log(args)
            // const {data} = await operacionCRUD({
            await operacionCRUD({
              variables: args
            });
          }
        }
      }
  
  //ENVIO PARA ACTUALIZAR BD
      async function updColecc(crudColecc, argsCrud, totDocCRUD) {
  // console.log(argsCrud)
  // console.log(totDocCRUD)
        let codigo = 0
        // console.log(argsCrud)
        if(argsCrud[0].ctrl_id === 'SI_ID'){
          codigo = await crudBD(crudColecc[0], argsCrud[0], 0)
        }else{
          await crudBD(crudColecc[0], argsCrud[0], 0)
        }
        if(codigo!==0){
          for(let i=1; i<totDocCRUD; i++){
            argsCrud[i]._id = codigo
          }
        }
  // console.log("inicio")
        for(let i=1; i<totDocCRUD; i++){
          await crudBD(crudColecc[i], argsCrud[i], i)
        }
  console.log("final")
      }

  if(ev.target.name==="pantalla"){
    let codProcDX = new Date().getTime();
    document.body.style.cursor = 'wait'
    // let fechaHoy = new Date()
    // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
    // let argsUpd
    let errors = []
    // if(!this.props.allClientesRtes.allClientesRtes||!this.props.allMovTodos.allMovTodos){
    if(!this.props.allClientesRtes.allClientesRtes){
      errors.push({path: "Generar DX", message: "Proceso de cargue de la información, por favor espere un momento..."});
    }
    if(!this.state.argsDocum.fechaRef){
      errors.push({path: "Fecha Ref", message: "Debe seleccionar la fecha de referencia"});
    }
    if(!this.state.argsDocum.diasMora||this.state.argsDocum.diasMora<=0){
      errors.push({path: "Dias Mora", message: "El número de días en mora debe ser mayor que 0"});
    }
    if(this.state.argsDocum.porcMovim>100){
      errors.push({path: "% Saldo", message: "El % no puede ser mayor que 100"});
    }
    // console.log(this.state.argsDocum)
    this.setState({errors})
    if(errors.length===0){
      let argsAdd = {}
      // console.log(this.state.servaDX)
      argsAdd['codProcDX'] = codProcDX.toString()
      argsAdd['fechaRef'] = this.state.argsDocum.fechaRef
      argsAdd['diasMora'] = this.state.argsDocum.diasMora
      argsAdd['diasDXDesde'] = this.state.argsDocum.diasDXDesde
      argsAdd['numVecesDX'] = this.state.argsDocum.numVecesDX
      if(this.state.argsDocum.porcMovim){argsAdd['porcMovim'] = this.state.argsDocum.porcMovim
        }else{argsAdd['porcMovim'] = 0}
      if(this.state.argsDocum.valorMovim){argsAdd['valorMovim'] = this.state.argsDocum.valorMovim
        }else{argsAdd['valorMovim'] = 0}
      if(this.state.servaDX==="clase"){
        argsAdd['servaDX'] = "Todos los servicios de la misma clase"
      }else{
        if(this.state.servaDX==="mora"){
          argsAdd['servaDX'] = "Solo los servicios en mora"
        }else{
          argsAdd['servaDX'] = "Todos los servicios"
        }
      }
      if(this.state.argsSelDpto.descrDpto&&this.state.argsSelDpto.descrDpto!=="Todos..."){
        argsAdd['descrDpto'] = this.state.argsSelDpto.descrDpto}else{
          argsAdd['descrDpto'] = "Todos los Departamentos"
      }
      if(this.state.argsSelDpto.nombreCiudad&&this.state.argsSelDpto.nombreCiudad!=="Todas..."){
        argsAdd['nombreCiudad'] = this.state.argsSelDpto.nombreCiudad}else{
          argsAdd['nombreCiudad'] = "Todas las Ciudades"
      }
      if(this.state.argsSelDpto.nombreZona&&this.state.argsSelDpto.nombreZona!=="Todas..."){
        argsAdd['nombreZona'] = this.state.argsSelDpto.nombreZona}else{
          argsAdd['nombreZona'] = "Todas las Zonas"
      }
      if(this.state.argsSelDpto.nombreBarrio&&this.state.argsSelDpto.nombreBarrio!=="Todas..."){
        argsAdd['nombreBarrio'] = this.state.argsSelDpto.nombreBarrio}else{
          argsAdd['nombreBarrio'] = "Todos los Barrios"
      }
      if(this.state.argsSelDpto.descrClaseServ&&this.state.argsSelDpto.descrClaseServ!=="Todas..."){
        argsAdd['descrClaseServ'] = this.state.argsSelDpto.descrClaseServ}else{
          argsAdd['descrClaseServ'] = "Todas las Clases"
      }
      // console.log(argsAdd)
      this.setState({argsProc: argsAdd});

      ///PARA PRUEBAS
      // // let clientesParaPruebas = this.props.allClientes.allClientes.filter(elemento => 
      // //   elemento.contrato==="11766"||elemento.contrato==="11769"||elemento.contrato==="11735")

      //   let clientesParaPruebas = this.props.allClientes.allClientes.filter(elemento => 
      //     elemento.contrato==="14489")
  
      //   let clientesDX = []
      //   if(!this.state.argsSelDpto.descrDpto||this.state.argsSelDpto.descrDpto==="Todos..."){
      //     clientesDX = clientesParaPruebas
      //   }else{
      //     if(!this.state.argsSelDpto.nombreCiudad||this.state.argsSelDpto.nombreCiudad==="Todas..."){
      //       clientesDX = clientesParaPruebas.filter(elemento => 
      //         elemento.dirmayor.descrDpto===this.state.argsSelDpto.descrDpto)
      //     }else{
      //       clientesDX = clientesParaPruebas.filter(elemento => 
      //         elemento.dirmayor.descrDpto===this.state.argsSelDpto.descrDpto&&
      //         elemento.dirmayor.ciudades.nombreCiudad===this.state.argsSelDpto.nombreCiudad)
      //     }
      //   }
      //FIN PARA PRUEBAS

      //PROCESO DE DX
      //Seleccionar clientes del dpto, ciudad, zona y barrio seleccionados

      let clientesDX = []
      // let argsBuscarCL = {estadoCliente: "ACTIVO", diasMoraIni: this.state.argsDocum.diasMora, diasMoraFin: 99999, numDocum: 2027}
      // if(this.state.argsSelDpto.descrClaseServ!==undefined&&this.state.argsSelDpto.descrClaseServ!=="Todas..."){
      //   argsBuscarCL.descrClaseServ=this.state.argsSelDpto.descrClaseServ
      // }else{
      //   argsBuscarCL.descrClaseServ=null
      // }
      // if(this.props.allClientes.allClientes){
      //   let {data} = await this.props.allClientes.refetch(argsBuscarCL)
      //   clientesDX = await data.allClientes
      // }

      let argsBuscarCL = `[{$match: {estadoCliente: "ACTIVO", saldoPendiente: {$gte: ${this.state.argsDocum.saldoPendiente}}, diasMora: {$gte: ${this.state.argsDocum.diasMora}}`
      if(this.state.argsSelDpto.descrClaseServ!==undefined&&this.state.argsSelDpto.descrClaseServ!=="Todas..."){
        argsBuscarCL += `, 'tarifa.servicios.subclaseserv.claseserv.descrClaseServ': '${this.state.argsSelDpto.descrClaseServ}'`
      }

      if(this.state.argsDocum.codigoTarifaN!=="Todas..."){
        // clientesDX = clientesDX.filter(elemento => elemento.tarifa.codigoTarifa===this.state.argsDocum.codigoTarifaN)
        argsBuscarCL += `, 'tarifa.codigoTarifa': '${this.state.argsDocum.codigoTarifaN}'`
      }

      if(!this.state.argsSelDpto.descrDpto||this.state.argsSelDpto.descrDpto==="Todos..."){
        // clientesDX = clientesDX.filter(elemento => elemento.numeroOdeDX===0&&
        //   elemento.saldoPendiente>0)saldoPendiente
        // argsBuscarCL += `, numeroOdeDX: 0, saldoPendiente: {$gt: 0}`
        argsBuscarCL += `, numeroOdeDX: 0`
      }else{
        if(!this.state.argsSelDpto.nombreCiudad||this.state.argsSelDpto.nombreCiudad==="Todas..."){
          // clientesDX = clientesDX.filter(elemento => 
          //   elemento.dirmayor.descrDpto===this.state.argsSelDpto.descrDpto&&elemento.numeroOdeDX===0&&
          //   elemento.saldoPendiente>0)
          argsBuscarCL += `, 'dirmayor.descrDpto': '${this.state.argsSelDpto.descrDpto}'`
          // argsBuscarCL += `, numeroOdeDX: 0, saldoPendiente: {$gt: 0}`
          argsBuscarCL += `, numeroOdeDX: 0`
        }else{
          if(!this.state.argsSelDpto.nombreZona||this.state.argsSelDpto.nombreZona==="Todas..."){
            // clientesDX = clientesDX.filter(elemento => 
            //   elemento.dirmayor.descrDpto===this.state.argsSelDpto.descrDpto&&
            //   elemento.dirmayor.ciudades.nombreCiudad===this.state.argsSelDpto.nombreCiudad&&
            //   elemento.numeroOdeDX===0&&elemento.saldoPendiente>0)
            argsBuscarCL += `, 'dirmayor.descrDpto': '${this.state.argsSelDpto.descrDpto}'`
            argsBuscarCL += `, 'dirmayor.ciudades.nombreCiudad': '${this.state.argsSelDpto.nombreCiudad}'`
            // argsBuscarCL += `, numeroOdeDX: 0, saldoPendiente: {$gt: 0}`
            argsBuscarCL += `, numeroOdeDX: 0`
          }else{
            if(!this.state.argsSelDpto.nombreBarrio||this.state.argsSelDpto.nombreBarrio==="Todos..."){
              // clientesDX = clientesDX.filter(elemento =>
              //   elemento.dirmayor.descrDpto===this.state.argsSelDpto.descrDpto&&
              //   elemento.dirmayor.ciudades.nombreCiudad===this.state.argsSelDpto.nombreCiudad&&
              //   elemento.dirmayor.ciudades.zonas.nombreZona===this.state.argsSelDpto.nombreZona&&
              //   elemento.numeroOdeDX===0&&elemento.saldoPendiente>0)
              argsBuscarCL += `, 'dirmayor.descrDpto': '${this.state.argsSelDpto.descrDpto}'`
              argsBuscarCL += `, 'dirmayor.ciudades.nombreCiudad': '${this.state.argsSelDpto.nombreCiudad}'`
              argsBuscarCL += `, 'dirmayor.ciudades.zonas.nombreZona': '${this.state.argsSelDpto.nombreZona}'`
              // argsBuscarCL += `, numeroOdeDX: 0, saldoPendiente: {$gt: 0}`
              argsBuscarCL += `, numeroOdeDX: 0`
            }else{
              // clientesDX = clientesDX.filter(elemento =>
              //   elemento.dirmayor.descrDpto===this.state.argsSelDpto.descrDpto&&
              //   elemento.dirmayor.ciudades.nombreCiudad===this.state.argsSelDpto.nombreCiudad&&
              //   elemento.dirmayor.ciudades.zonas.nombreZona===this.state.argsSelDpto.nombreZona&&
              //   elemento.dirmayor.ciudades.zonas.barrios.nombreBarrio===this.state.argsSelDpto.nombreBarrio&&
              //   elemento.numeroOdeDX===0&&elemento.saldoPendiente>0)
              argsBuscarCL += `, 'dirmayor.descrDpto': '${this.state.argsSelDpto.descrDpto}'`
              argsBuscarCL += `, 'dirmayor.ciudades.nombreCiudad': '${this.state.argsSelDpto.nombreCiudad}'`
              argsBuscarCL += `, 'dirmayor.ciudades.zonas.nombreZona': '${this.state.argsSelDpto.nombreZona}'`
              argsBuscarCL += `, 'dirmayor.ciudades.zonas.barrios.nombreBarrio': '${this.state.argsSelDpto.nombreBarrio}'`
              // argsBuscarCL += `, numeroOdeDX: 0, saldoPendiente: {$gt: 0}`
              argsBuscarCL += `, numeroOdeDX: 0`
            }
          }
        }
      }
      argsBuscarCL += `}},
        {$lookup: {
          from: "movclientes",
          let: {contrato: "$contrato", valorPagado: "$valorPagado"},
          pipeline: [
            {$match: {$expr: {$eq: ["$contrato",  "$$contrato"]}}},
            {$match: {tipo: "C", numeroOdeDX: 0, valorPendiente: {$gt: 0}, $expr: {$gt: ["$valorTotal",  "$$valorPagado"]}}},
          ],
          as: "movimientos"
        }}
      `
      argsBuscarCL = {tipoqry: `${argsBuscarCL}]`}
      if(this.props.allClientesRtes.allClientesRtes){
        // console.log(argsBuscarCL)
        let {data} = await this.props.allClientesRtes.refetch(argsBuscarCL)
        clientesDX = await data.allClientesRtes
      }
      // console.log(clientesDX)

      let movimDXMov = []
      clientesDX.map((elemento, i) => {
        // for(let ii=0; ii<elemento.movimientos.length; ii++){
        for(let ii=elemento.movimientos.length - 1; ii>=0; ii--){
          movimDXMov.push({
            _id: elemento.movimientos[ii]._id,
            contrato: elemento.contrato,
            codigoServicio: elemento.movimientos[ii].codigoServicio,
            descripcionServicio: elemento.movimientos[ii].descripcionServicio,
            descrClaseServ: elemento.movimientos[ii].descrClaseServ,
            documento: elemento.movimientos[ii].documento,
            pagueHasta: elemento.movimientos[ii].pagueHasta,
            valorPagado: elemento.movimientos[ii].valorPagado,
            valorTotal: elemento.movimientos[ii].valorTotal
          })
        };
      })

      let diasMora = this.state.argsDocum.diasMora, fecha = new Date(this.state.argsDocum.fechaRef)
      let fechaMora = fecha.setDate(fecha.getUTCDate() - diasMora)
      fechaMora = new Date(fechaMora)
      fechaMora = (fechaMora.getFullYear()) + '-' + ((fechaMora.getMonth()+1)<10?'0'+(fechaMora.getMonth()+1):(fechaMora.getMonth()+1)) + '-' + (fechaMora.getUTCDate()<10?'0'+fechaMora.getUTCDate():fechaMora.getUTCDate())
      // console.log(fechaMora)
      // let movimDXMov = []
      // // let argsBuscarMC = {tipo: "C", pagueHasta: { $lte: fechaMora }, numeroOdeDX: 0}
      // let argsBuscarMC = {tipo: "C", numeroOdeDX: 0, valorPendiente: {$gt: 0}, tipoProc: "Proceso DX masiva"}
      // if(this.props.allMovTodos.allMovTodos){
      //   console.log(argsBuscarMC)
      //   let {data} = await this.props.allMovTodos.refetch(argsBuscarMC)
      //   movimDXMov = await data.allMovTodos

      //   // movimDXMov = await movimDXMov.filter(movim => movim.valorTotal > movim.valorPagado)
      // }
      // console.log(movimDXMov)
      // console.log(clientesDX)
      let vecesCliDX = []

      // if(this.state.argsDocum.diasDXDesde>0&&this.state.argsDocum.numVecesDX>=0){
        let argsQuery1 = `
          {$project: {_id: 0, numeroOdeDX: 1, contrato: 1, estadoDetDX: 1,
            diasdx: {
              $let: {
                vars: {pagueHastaDif: { $subtract: [ new Date(), "$fechaCreate" ]}},
                in: { $toInt: {$divide: [ "$$pagueHastaDif", 86400000 ]} }
              }
            }
          }},
          {$match: {diasdx: {$lte: ${this.state.argsDocum.diasDXDesde}}, estadoDetDX: 'DX'}},
          {$group: {_id: {numeroOdeDX: '$numeroOdeDX', contrato: '$contrato'}, numVecesDX: { $sum: 1 }}},
          {$group: {_id: '$_id.contrato', numVecesDX: { $sum: 1 }}},
          {$match: {'numVecesDX': {$gte: ${this.state.argsDocum.numVecesDX}}}},
          {$project: {_id: 0, contrato: '$_id', numVecesDX: {$toInt: '$numVecesDX'}}}`  
        let argsBuscarDX = {}
        argsBuscarDX = {tipoqry: `[${argsQuery1}]`}
        // console.log(argsBuscarDX)
        if(this.props.allDetalleDXRtes.allDetalleDXRtes){
          let {data} = await this.props.allDetalleDXRtes.refetch(argsBuscarDX)
          vecesCliDX = await data.allDetalleDXRtes
        // console.log(vecesCliDX)
        }
      // }

      // console.log(movimDXMov)
      // console.log(this.props.allMovTodos.allMovTodos)
      // console.log(this.state.argsDocum)
      // console.log(argsBuscarMC)
      let creaDetDX = []
      let totCli = 0

      //cambiar this.props.allMovTodos.allMovTodos por movimDX => revisarlo y si es asi cambiarlo
      // clientesDX.forEach(async (elemento, _id) => {
      for(let ii=0; ii<clientesDX.length; ii++){
        let elemento = clientesDX[ii]
        let cliDX = false

        let numVecesDX = 0
        // if(this.state.argsDocum.diasDXDesde>0&&this.state.argsDocum.numVecesDX>0){
        const indexSearchDX = vecesCliDX.findIndex( elemCliDX => elemCliDX.contrato===elemento.contrato )
        if(indexSearchDX!==-1){
          // console.log(vecesCliDX[indexSearchDX])
          numVecesDX = vecesCliDX[indexSearchDX].numVecesDX
        }
        // }

        if((elemento.numeroOdeDX===0&&this.state.argsDocum.numVecesDX===0)||
          (elemento.numeroOdeDX===0&&numVecesDX >= this.state.argsDocum.numVecesDX)){
            // console.log(elemento.contrato, elemento.numeroOdeDX, numVecesDX, this.state.argsDocum.numVecesDX)
          let movimDX = []
          if(this.state.argsDocum.porcMovim>0&&this.state.argsDocum.valorMovim>0){
            movimDX = movimDXMov.filter(movim => movim.contrato===elemento.contrato&&
                          movim.valorTotal - movim.valorPagado>=(movim.valorTotal*this.state.argsDocum.porcMovim)/100&&
                          movim.valorTotal - movim.valorPagado>=this.state.argsDocum.valorMovim)
          }else{
            if(this.state.argsDocum.porcMovim>0){
              movimDX = movimDXMov.filter(movim => movim.contrato===elemento.contrato&&
                movim.valorTotal - movim.valorPagado>=(movim.valorTotal*this.state.argsDocum.porcMovim)/100)
            }else{
              if(this.state.argsDocum.valorMovim>0){
                movimDX = movimDXMov.filter(movim => movim.contrato===elemento.contrato&&
                  movim.valorTotal - movim.valorPagado>=this.state.argsDocum.valorMovim)
                }else{
                movimDX = movimDXMov.filter(movim => movim.contrato===elemento.contrato)
              }
            }
          }
          // console.log(movimDX)

          let fechaHoy = new Date()
          let fechaHoy1 = new Date()
          let diasHoy = fechaHoy1.getUTCDate()
          let mesHoy = fechaHoy1.getMonth()+1
          movimDX = movimDX.map(movim => ({
            ...movim, numVecesDX, diasMora: movim.pagueHasta?Math.round(parseInt((new Date(this.state.argsDocum.fechaRef).getTime() - new Date(movim.pagueHasta.substr(0, 10)).getTime()) / (1000*60*60*24), 10)):0}))
            // if(elemento.contrato==="94886"){
            //   console.log(movimDX)
            // }
          movimDX.forEach((elemento1, i) => {
            // console.log(elemento1)
            //Validar si el servicio es de la clase seleccionada
            // console.log(this.state.argsSelDpto)
            if(elemento1.diasMora>0){
              if(!this.state.argsSelDpto.descrClaseServ||this.state.argsSelDpto.descrClaseServ==="Todas..."||
                (this.state.argsSelDpto.descrClaseServ&&this.state.argsSelDpto.descrClaseServ===elemento1.descrClaseServ)){
                  const indexSearch = this.props.allServicios.allServicios.findIndex( servicio => servicio.codigoServicio===elemento1.codigoServicio )
                // console.log(indexSearch)
                if(indexSearch!==-1||elemento1.codigoServicio==="SISTV"||elemento1.codigoServicio==="SINET"){
                  elemento.tarifa.servicios.forEach(async (elemento2, _id) => {
                    // console.log(elemento2)
                  if(elemento2.estadoServicio === "A"||elemento1.codigoServicio==="SISTV"||elemento1.codigoServicio==="SINET"){
                    let dxServ = false
                    if(this.state.servaDX==="clase"){
                    //Todos los servicios de la misma clase
                      if(elemento1.descrClaseServ===elemento2.subclaseserv.claseserv.descrClaseServ){
                        dxServ = true
                      }
                    }else{
                      if(this.state.servaDX==="mora"){
                        //Solo los servicios en mora
                        if(elemento1.codigoServicio===elemento2.codigoServicio){
                          dxServ = true
                        }
                      }else{
                        //Todos los servicios
                        dxServ = true
                      }
                    }
                      if(dxServ){
                        //Buscar que el servicio no este en la lista
                        const indexSearchS = creaDetDX.findIndex( servicio => servicio.contrato===elemento.contrato&&
                          servicio.codigoServicio===elemento2.codigoServicio )
                        // console.log(indexSearchS)
                        if(indexSearchS===-1){
                          //calcular pagohasta para el servicio
                          let diasMoraServ = 0
                          if(elemento1.pagueHasta&&elemento1.valorTotal>elemento1.valorPagado&&elemento1.valorTotal>0){
                            // console.log(elemento.cargoMensual, elemento1.codigoServicio)
                            if((elemento1.codigoServicio==="SISTV"||elemento1.codigoServicio==="SINET")&&elemento.cargoMensual>0){
                              //Math.ceil redondea al entero por encima
                              let mesesM = Math.ceil((elemento1.valorTotal - elemento1.valorPagado) / elemento.cargoMensual)
                              if(elemento1.codigoServicio==="SISTV"){
                                diasMoraServ = ((mesHoy-6+mesesM) * 30) + diasHoy
                              }else{
                                diasMoraServ = ((mesHoy-5+mesesM) * 30) + diasHoy - 15
                              }
                              // console.log(elemento1.contrato, elemento1.codigoServicio, mesesM, diasMoraServ)
                            }else{
                              diasMoraServ = elemento1.diasMora
                              // console.log(elemento1.contrato, elemento1.codigoServicio, diasMoraServ)
                            }
                          }
                          // if(diasMoraServ<=0){
                          //   diasMoraServ = 0
                          // }
                          // let fechaPH = fechaHoy
                          // if(diasMoraServ<>0){
                          let fechaInicio = new Date(fechaHoy).getTime();
                          let fechaFin = new Date(fechaInicio-(diasMoraServ*1000*60*60*24));
                          let fechaPH = (fechaFin.getFullYear()) + '-' + ((fechaFin.getMonth()+1)<10?'0'+(fechaFin.getMonth()+1):(fechaFin.getMonth()+1)) + '-' + (fechaFin.getUTCDate()<10?'0'+fechaFin.getUTCDate():fechaFin.getUTCDate())
                          // }
                          //FIN calcular pagohasta para el servicio

                          let fechaIni = new Date(this.state.argsDocum.fechaRef).getTime();
                          fechaFin = new Date(fechaPH).getTime();
                          let numdiasMora = parseInt((fechaIni - fechaFin) / (1000*60*60*24), 10)
                          // console.log(fechaPH, fechaMora, fechaInicio, fechaFin)
                          if(fechaPH<=fechaMora){
                            // console.log("servicio en mora", elemento2.descripcionServicio, numdiasMora)
                            // }
                            let argsUpd = {}
                            argsUpd = {
                              "numeroOdeDX": 0,
                              "contrato": elemento.contrato,
                              "codigoTarifa": elemento.tarifa.codigoTarifa,
                              //Servicio a DX
                              "codigoServicio": elemento2.codigoServicio,
                              "descripcionServicio": elemento2.descripcionServicio,
                              "descrClaseServ": elemento2.subclaseserv.claseserv.descrClaseServ,
                              //Servicio en mora
                              "idMovim": elemento1._id,
                              "codigoServicioM": elemento1.codigoServicio,
                              "descripcionServicioM": elemento1.descripcionServicio,
                              "descrClaseServM": elemento1.descrClaseServ,
                              "documento": elemento1.documento,
                              "valorTotal": elemento1.valorTotal,
                              "valorPagado": elemento1.valorPagado,
                              "pagueHasta": fechaPH,
                              "diasMora": numdiasMora,
                              "numVecesDX": elemento1.numVecesDX,
                              "estadoDetDX": "GE",
                              "usuarioCreate": sessionStorage.getItem('userLogin')
                            }
                            creaDetDX.push(argsUpd)

                            cliDX = true
                          }
                        }
                      }
                    }
                  })
                }
              }
            }
          })
        }
        if(cliDX){
          totCli += 1
        }
        // })
      }
      // console.log(creaDetDX)
      this.setState({creaDetDX})
      this.setState({totCli})

      clientesDX = []
      argsBuscarCL={tipoqry: `[{$match: {contrato: "XXXYYYZZZ"}}]`}
      // argsBuscarCL.numDocum = 1
      if(this.props.allClientesRtes.allClientesRtes){
        let {data} = await this.props.allClientesRtes.refetch(argsBuscarCL)
        clientesDX = await data.allClientesRtes
      }

      movimDXMov = []
      // argsBuscarMC={}
      // argsBuscarMC = {tipo: "X"}
      // if(this.props.allMovTodos.allMovTodos){
      //   let {data} = await this.props.allMovTodos.refetch(argsBuscarMC)
      //   movimDXMov = await data.allMovTodos
      // }

        // console.log(clientesDX, movimDXMov)
      }
      document.body.style.cursor = 'default'
    }else{
//GENERAR DX MASIVA
      let errors = []
      if(this.state.creaDetDX.length===0){
        errors.push({path: "Generar DX", message: "No hay servicios a DX"});
      }
      this.setState({errors})
      if(errors.length===0){
        let numDX = await this.nextVal('dxm')

        let argsProc = this.state.argsProc
        argsProc['numeroOdeDX'] = numDX
        argsProc['estadoProcDX'] = "ABIERTA"
        argsProc['totCliDX'] = this.state.totCli
        argsProc['totServDX'] = this.state.creaDetDX.length

        const response = await this.props.createProcDX({
          variables: argsProc
        });
        const {errors, success} = response.data.createProcDX;
        if (!success){
          this.setState({errorAdd: errors})
        }

        let creaDetDX = this.state.creaDetDX.map(movim => ({
          ...movim, numeroOdeDX: numDX}))
// console.log(creaDetDX)

//Crear detalleDX
//Actualizar numeroOdeDX en movclientes y en clientes
//Actualizar estadoServicio en los servicios de la tarifa del cliente que se DX
        let creaDetDXMany = []

        creaDetDX.forEach((elementoDX, ii) => {
          creaDetDXMany.push(elementoDX)
        })

        let creaDetDXMany1 = []
        creaDetDXMany1.push({detalledx: creaDetDXMany})

        let numDocCRUD = 0
        let totDocCRUD = 1
        let argsCrud = []
        let crudColecc = []
        for(let iii=0; iii<totDocCRUD; iii++){
          argsCrud.push({ctrlCampo: 'NO_CRUD'})
        }
        for(let iii=0; iii<totDocCRUD; iii++){
          crudColecc.push(this.props.createDetalleDXMany)
        }
  
        argsCrud[numDocCRUD] = creaDetDXMany1[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.createDetalleDXMany
  
        // console.log(argsCrud)
        // console.log(totDocCRUD)
        updColecc(crudColecc, argsCrud, totDocCRUD)

        creaDetDX = []
        argsProc = {}
        this.setState({creaDetDX})
        this.setState({argsProc})
      }
    }
    console.log("listooooo")
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false, confirmaAct: false})};
    if(btnPress==="No"){
        this.setState({open: false})
    };
    if(btnPress==="Si"){
        this.setState({confirmaAct: true})
        this.setState({open: false})
        const myBtn = await document.getElementById("btnUpdDel");
        myBtn.click()
    }
  }

  async UNSAFE_componentWillMount(){
    if(this.state.argsDocum.fechaRef===""){
      const argsDocum = this.state.argsDocum
      const response = await this.props.fecha({
        variables: {}
      });
      const {fechaFechaHoy} = await response.data.fecha
      argsDocum['fechaRef'] = fechaFechaHoy.substr(0,10)
      this.setState(argsDocum)
    }
  }

  componentDidUpdate(prevProps){
    if(this.props.argsSelDpto.codigoCiudad!==undefined&&this.props.argsSelDpto.codigoCiudad!==""){
      let miLista = document.getElementById("miLista1");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoCiudad){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreCiudad'] = "Todas..."
        argsSelDpto['codigoCiudad'] = ""
        argsSelDpto['codigoCiudadInterno'] = ""
        argsSelDpto['codBarrasRdo'] = ""
        this.setState({argsSelDpto})
      }
    }
    if(this.props.argsSelDpto.codigoZona!==undefined&&this.props.argsSelDpto.codigoZona!==""){
      let miLista = document.getElementById("miLista2");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoZona){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreZona'] = "Todas..."
        argsSelDpto['codigoZona'] = ""
        this.setState({argsSelDpto})
      }
    }
    if(this.props.argsSelDpto.codigoBarrio!==undefined&&this.props.argsSelDpto.codigoBarrio!==""){
      let miLista = document.getElementById("miLista3");
      if(miLista.options[miLista.selectedIndex].value!==this.props.argsSelDpto.codigoBarrio){
        const argsSelDpto = this.state.argsSelDpto
        argsSelDpto['nombreBarrio'] = "Todos..."
        argsSelDpto['codigoBarrio'] = ""
        argsSelDpto['codigoTipoDocT'] = ""
        argsSelDpto['numeroDocumT'] = ""
        argsSelDpto['descrRecursoT'] = ""
        argsSelDpto['codigoTipoDocR'] = ""
        argsSelDpto['numeroDocumR'] = ""
        argsSelDpto['descrRecursoR'] = ""
        this.setState({argsSelDpto})
      }
    }
    if(this.props.argsSelDpto.descrDpto!==this.state.argsDocum.descrDpto||
        this.props.argsSelDpto.nombreCiudad!==this.state.argsDocum.nombreCiudad||
        this.props.argsSelDpto.nombreZona!==this.state.argsDocum.nombreZona||
        this.props.argsSelDpto.nombreBarrio!==this.state.argsDocum.nombreBarrio){
      const argsDocum = this.state.argsDocum
      argsDocum.descrDpto = this.props.argsSelDpto.descrDpto
      argsDocum.nombreCiudad = this.props.argsSelDpto.nombreCiudad
      argsDocum.nombreZona = this.props.argsSelDpto.nombreZona
      argsDocum.nombreBarrio = this.props.argsSelDpto.nombreBarrio
      this.setState({argsDocum});
      this.setState({argsSelDpto: this.props.argsSelDpto})
      let creaDetDX = [], argsProc = {}
      this.setState({creaDetDX})
      this.setState({argsProc})
    }

    // if(this.props.argsSelDpto!==prevProps.argsSelDpto){
    //   this.setState({argsSelDpto: this.props.argsSelDpto})
    // }
  }

  render(){
    // const {argsDocum, argsProc, servaDX, argsSelDpto, actmovCli, creaDetDX, totCli, permiteUpdate, confirmaAct, open, errors} = this.state;
    const {argsDocum, creaDetDX, totCli, permiteUpdate, confirmaAct, open, errors} = this.state;

    if(this.props.codigoCiudadUA!=="Todas..."){
      let dpto = document.getElementById("miLista");
      if(dpto){
        dpto.options.selectedIndex = 0
      }
    }

    let colecc = selDirmayor(this.props.list1, this.props.argsSelDpto, this.props.codigoCiudadUA)
    let listCiu = colecc.listCiu
    let listZon = colecc.listZon
    let listBar = colecc.listBar

    let list6 = []
    if(this.props.allTarifa.allTarifa){list6 = this.props.allTarifa.allTarifa}
    // console.log(list6)
    // console.log(argsDocum)

    // let fechaHoy = new Date()
    // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())

    let mensaje = "GENERAR DX MASIVA"
    let imgIcon = "images/archivo_32.png"
    // console.log(this.props.allClientes.allClientes)
    // console.log(this.props.allMovTodos.allMovTodos)
    // console.log(this.props.allServicios.allServicios)
    // console.log(this.props.list)
    // console.log(argsSelDpto)
    return(
      <div>
          <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
              <i className="large plus yellow icon"></i>
              Generar DX masiva
          </button>
          <div>
                    <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
                    <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev):()=>{}}>
                        <div>
                            <div className="ui two column stackable grid">
                                <div className="row container">
                                    <div className="column" style={{width: '50%'}}>
                                      <h1 style={{color: '#2C7744'}}>Generar DX masiva</h1>
                                      <p style={{color: '#302b63', fontStyle: 'italic', paddingTop: '0em'}}>
                                          Seleccionar los clientes y servicios a DX. Los días en mora<br/>
                                          se calculan asi: Fecha de referencia - Fecha límite de pago
                                      </p>
                                    </div>
                                    <div className="column" style={{width: '50%'}}>
                                      <p>
                                        <span style={{background: '#7F7FD5', padding: '0.5em', color: 'white', fontSize: '1.2em'}} className='ui basic label'>
                                          Fecha de referencia: &nbsp;&nbsp;
                                          <span>
                                            <input value={argsDocum.fechaRef} style={{color: '#302b63', fontSize: '2em', padding: '0.5em'}} type='date' name="fechaRef" id="fechaRef" onChange={this.handleChange}/>
                                          </span>
                                        </span>
                                      </p>
                                    </div>
                                </div>
                            </div>
                            <hr></hr>
                            <div className="ui two column stackable grid">
                              <div className="row container">
                                  <div className="column" style={{width: '50%'}}>
                                    <Form.Field>
                                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                        CLIENTES con saldo pendiente por pagar mayor o igual a $ XX
                                      </label>
                                      <input autoFocus value={argsDocum.saldoPendiente} type='number' step="1" min="1" style={this.props.styles.input} autoComplete="off" name="saldoPendiente" id="saldoPendiente" placeholder='$ saldo pendiente CLIENTE' onChange={this.handleChange}/>
                                    </Form.Field>
                                  </div>
                                  <div className="column" style={{width: '50%'}}>
                                    <Form.Field>
                                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                        MOVIMIENTOS con mora mayor o igual a XX días
                                      </label>
                                      <input value={argsDocum.diasMora} type='number' step="1" min="1" style={this.props.styles.input} autoComplete="off" name="diasMora" id="diasMora" placeholder='Días en mora' onChange={this.handleChange}/>
                                    </Form.Field>
                                  </div>
                              </div>
                            </div>
                            <Form.Field>
                              <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                MOVIMIENTOS con saldo pendiente por pagar mayor o igual a XX % del valor del movimiento
                              </label>
                              <input type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="porcMovim" id="porcMovim" placeholder='% saldo pendiente' onChange={this.handleChange}/>
                            </Form.Field>
                            <Form.Field>
                              <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                MOVIMIENTOS con saldo pendiente por pagar mayor o igual a $ XX
                              </label>
                              <input type='number' step="1" min="1" style={this.props.styles.input} autoComplete="off" name="valorMovim" id="valorMovim" placeholder='$ saldo pendiente MOVIMIENTO' onChange={this.handleChange}/>
                            </Form.Field>
                            <div className="ui two column stackable grid">
                              <div className="row container">
                                  <div className="column" style={{width: '50%'}}>
                                    <Form.Field>
                                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                        En los últimos XXX días
                                      </label>
                                      <input value={argsDocum.diasDXDesde} type='number' step="1" min="1" style={this.props.styles.input} autoComplete="off" name="diasDXDesde" id="diasDXDesde" placeholder='días' onChange={this.handleChange}/>
                                    </Form.Field>
                                  </div>
                                  <div className="column" style={{width: '50%'}}>
                                  <Form.Field>
                                      <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                        Se DX X o más veces
                                      </label>
                                      <input value={argsDocum.numVecesDX} type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="numVecesDX" id="numVecesDX" placeholder='# DX' onChange={this.handleChange}/>
                                    </Form.Field>
                                  </div>
                              </div>
                            </div>
                            <hr></hr>
                            {/* <fieldset><legend style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;&nbsp;&nbsp;DX&nbsp;&nbsp;&nbsp;</legend> */}
                                  {/* <input style={{height: '1.2em', width: '1.2em'}} type="radio" name="opcServaDX" value="clase" defaultChecked="true"  onChange={this.handleChange}></input> */}
                              {/* <input style={{height: '1.2em', width: '1.2em'}} type="radio" name="opcServaDX" value="clase" onChange={this.handleChange}></input>
                              <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Todos los servicios de la misma clase&nbsp;&nbsp;&nbsp;</label>
                              <input style={{height: '1.2em', width: '1.2em'}} type="radio" name="opcServaDX" value="mora" onChange={this.handleChange}></input>
                              <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Solo los servicios en mora&nbsp;&nbsp;&nbsp;</label> */}
                                  {/* <input style={{height: '1.2em', width: '1.2em'}} type="radio" name="opcServaDX" value="todos" onChange={this.handleChange}></input> */}
                              {/* <input style={{height: '1.2em', width: '1.2em'}} type="radio" name="opcServaDX" value="todos" defaultChecked="true" onChange={this.handleChange}></input>
                              <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold'}}>&nbsp;Todos los servicios</label>
                            </fieldset> */}
                            <hr></hr>


                            <div className="ui two column stackable grid">
                              <div className="row container">
                                <div className="column" style={{width: '50%'}}>
                                  <Form.Field>
                                    <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                      Departamento
                                    </label>
                                    <ListaDe list={this.props.list1} styles={this.props.styles}
                                      handleLista={this.props.handleLista} codigoCiudadUA={this.props.codigoCiudadUA}
                                      codigoDptoUA={this.props.codigoDptoUA}/>
                                  </Form.Field>
                                </div>
                                <div className="column" style={{width: '50%'}}>
                                  <Form.Field>
                                    <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                      Ciudad
                                    </label>
                                    <ListaCi list={listCiu} styles={this.props.styles}
                                      handleLista1={this.props.handleLista1} argsSelDpto={this.props.argsSelDpto}
                                      codigoCiudadUA={this.props.codigoCiudadUA}/>
                                  </Form.Field>
                                </div>
                                <div className="column" style={{width: '50%'}}>
                                  <Form.Field>
                                    <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                      Zona
                                    </label>
                                    <ListaZo list={listZon} styles={this.props.styles}
                                      handleLista2={this.props.handleLista2} argsSelDpto={this.props.argsSelDpto}/>
                                  </Form.Field>
                                </div>
                                <div className="column" style={{width: '50%'}}>
                                  <Form.Field>
                                    <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                      Barrio
                                    </label>
                                    <ListaBa list={listBar} styles={this.props.styles}
                                      handleLista3={this.props.handleLista3} argsSelDpto={this.props.argsSelDpto}/>
                                  </Form.Field>
                                </div>
                              </div>
                            </div>

                            <hr></hr>
                            <div className="ui two column stackable grid">
                              <div className="row container">
                                <div className="column" style={{width: '50%'}}>
                                  <Form.Field>
                                    <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                      Clase
                                    </label>
                                    <Lista styles={this.props.styles} list={this.props.list2} handleLista4={this.props.handleLista4}  argsSelDpto={this.props.argsSelDpto}/>
                                  </Form.Field>
                                </div>
                                <div className="column" style={{width: '50%'}}>
                                  <Form.Field>
                                    <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                      Tarifa
                                    </label>
                                    <ListaTarN styles={this.props.styles} list={list6} handleChange={this.handleChange} />
                                  </Form.Field>
                                </div>
                              </div>
                            </div>



                            {/* <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                              Clase
                            </p>
                            <Form.Field>
                              <Lista styles={this.props.styles} list={this.props.list2} handleLista4={this.props.handleLista4}  argsSelDpto={this.props.argsSelDpto}/>
                            </Form.Field> */}
                            <hr></hr>
                            <hr></hr>

                            <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                              Totales a DX:  Clientes:&nbsp;
                              {totCli}&nbsp;&nbsp;&nbsp;&nbsp;
                              Servicios:&nbsp;
                              {creaDetDX.length}
                            </p>

                            <div className="ui two column stackable grid">
                              <div className="row container">
                                <div className="column" style={{width: '50%'}}>
                                  <Button id="pantalla" name="pantalla" style={this.props.styles.confirmar} onClick={(ev)=>this.handleSubmit(ev)} fluid>
                                      VER SERVICIOS A DX
                                  </Button>
                                </div>
                                <div className="column" style={{width: '50%'}}>
                                  <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                                </div>
                              </div>
                            </div>
                            <hr></hr>
                            <table id="tablaDX" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                              <thead className=''>
                                <tr className=''>
                                  <th rowSpan='2'  className=''>Contrato</th>
                                  <th colSpan='2' className='center aligned'>Servicio a DX</th>
                                  <th colSpan='7' className='center aligned'>Servicio en mora</th>
                                </tr>
                                <tr className=''>
                                  <th className=''>Clase</th>
                                  <th className=''>Servicio</th>
                                  <th className=''>Clase</th>
                                  <th className=''>Servicio</th>
                                  <th className=''>Documento</th>
                                  <th className='right aligned'>$ Total</th>
                                  <th className='right aligned'>$ Pagado</th>
                                  <th className=''>Pague hasta</th>
                                  <th className=''>Mora</th>
                                  <th className=''># DX</th>
                                </tr>
                              </thead>
                              <ListaDX list={creaDetDX}/>
                            </table>
                        </div>
                        
                      {
                          errors.length?<Message negative header="Los siguientes errores:"
                          list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                      }

                      </Form>
                    </div>
                </div>
      </div>
    )
  }
}

export default compose(
  // graphql(queries.query.allClientes, {name:'allClientes', options: (props) => {return {variables: argsBuscarCL}}}),
  graphql(queries.query.allClientesRtes, {name:'allClientesRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {contrato: "XXXYYYZZZ"}}]`}}}}),

  graphql(queries.mutation.createProcDX, {name:'createProcDX'}),

  graphql(queries.query.allTarifa, {name:'allTarifa', options: (props) => {return {variables: {}}}}),

  graphql(queries.query.allDetalleDXRtes, {name:'allDetalleDXRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {contrato: 'XYZ321'}}, {$project: {contrato: 1}}]`}}}}),

  // graphql(queries.query.allMovTodos, {name:'allMovTodos', options: (props) => {return {variables: argsBuscarMC}}}),
  
  graphql(queries.mutation.createDetalleDXMany, {name:'createDetalleDXMany'}),

  graphql(queries.query.allServicios, {name:'allServicios', options: (props) => {return {variables: {paraProcMasDX: "SI"}}}}),

  graphql(queries.mutation.editSeqfindOneAndUpdate, {name:'editSeqfindOneAndUpdate'}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(ProcDX2)
